/**
 * After how long a visit somebody has counts as stuck: hg-order's three
 * norms, in minutes. The orders' screens show a stuck visit against them,
 * and administration sets them: one copy for both.
 */
import { queryOptions } from "@tanstack/react-query";

import { orderApi, unwrap } from "@/shared/api/clients";

export const STUCK_SETTINGS_KEY = ["order", "reference", "stuck-visits"] as const;

export const stuckSettingsQuery = queryOptions({
  queryKey: STUCK_SETTINGS_KEY,
  queryFn: async ({ signal }) => {
    const { data } = await unwrap(orderApi.GET("/v2/admin/stuck-visit-settings", { signal }));
    return data;
  },
  staleTime: 5 * 60_000,
});
